export const TRADE_TABS = [
 'open_orders',
 'accepted_orders',
 'dispatched_orders',
 'pending_payment_orders',
 'completed_orders',
 'rejected_cancelled_orders',
] as const

export type TradeTabId = (typeof TRADE_TABS)[number]

export type TradeDeepLink = {
 tab: TradeTabId
 orderId?: string
}

export const DEFAULT_TRADE_TAB: TradeTabId = 'open_orders'

export const isValidTradeTab = (
 tab: string
): tab is TradeTabId =>
 TRADE_TABS.includes(tab as TradeTabId)

export const getTradeListPath = (
 tab: TradeTabId = DEFAULT_TRADE_TAB
) => `/trade/${tab}`

export const getTradeOrderPath = (
 tab: TradeTabId,
 orderId: string | number
) => `/trade/${tab}/${orderId}`
